import orderStatusBanner from 'html/layouts/order-status-banner.html';
import App from 'app/app.js';
import 'app/directive/LtOrderStatusBannerCtrl.js';

function LtOrderStatusBannerDirective() {
  return {
    restrict: 'E',
    scope: {},
    template: orderStatusBanner,
    controller: 'LtOrderStatusBannerCtrl',
    controllerAs: 'orderStatusBanner'
  };
}

App.directive('ltOrderStatusBanner', [LtOrderStatusBannerDirective]);
